<template>
    <div class="center-box">
        <title1 title="综合态势" :isBg="false" fontSize="32" />
        <div
            v-for="(item, i) in target1"
            :key="'target1' + i"
            class="flex align-center target4"
            :class="{'hidden': pathName == 'changingElectricityMerge' && i == 1}">
            <img class="img" :src="item.icon" />
            <div class="flex flex-direction flex1">
                <div class="label">{{ item.label}}</div>
                <div class="num flex align-center fs-center" :style="{'color': item.color}">
                    <slot v-if="item.overTenThousand">{{ item.number | overTenThousandUnit }}</slot>
                    <slot v-else>{{ item.number }}</slot>
                </div>
                <!-- <dv-digital-flop class="num" :config="dvDigitalFlopConfig(item)" /> -->
            </div>
        </div>
    </div>
</template>

<script>
import title1 from '@/views/exposition/components/title1'
import { dataInterface } from '@/api/dataInterfaceApi'
// import myEchart from '@/views/exposition/components/charts/echarts'
// import * as echarts from 'echarts5'
export default {
    components: {
        title1,
        // myEchart
    },
    data() {
        return {
            pathName: this.$route.name,
            target1: [
                {
                    icon: require('@/assets/images/exposition/chd-1.png'),
                    number: '',
                    label: '充电站数量(座)',
                    color: '#36FBFB'
                },
                {
                    icon: require('@/assets/images/exposition/chd-2.png'),
                    number: '',
                    label: '换电站数量(座)',
                    color: '#43FFB9'
                },
                {
                    icon: require('@/assets/images/exposition/chd-3.png'),
                    number: '',
                    label: '累计充换电电量(kwh)',
                    overTenThousand: true,
                    color: '#FFFFFF'
                },
                {
                    icon: require('@/assets/images/exposition/chd-4.png'),
                    number: '',
                    label: '累计换电里程(km)',
                    overTenThousand: true,
                    color: '#179DFF'
                },
                {
                    icon: require('@/assets/images/exposition/chd-5.png'),
                    number: '',
                    label: '充换电次数(次)',
                    overTenThousand: true,
                    color: '#36FBFB'
                },
            ],
        }
    },
	methods: {
        dvDigitalFlopConfig(item = {}) {
            let number = parseFloat(item.number || 0)
            let config = {
                number: [parseInt(number > 10000 ? (number / 10000) : number)],
                textAlign: item.textAlign || 'left',
                content: number > 10000 ? '{nt}w' : '{nt}',
                style: {
                    fill: item.color || '#fff',
                    fontSize: item.fontSize || 60,
                }
            }
            return config
        },
		getData(data) {
            console.log('snec充换电首页center-1')
            if(this.pathName == 'changingElectricityMerge') {
                this.zongheTaiShi1(data)
            } else {
                this.zongheTaiShi1(data, 0)
                this.zongheTaiShi1(data, 1)
            }
            this.zongheTaiShi2(data)
        },
        zongheTaiShi1(data = {}, type) {
            let province = data.province || data.city || data.district || '000000'
			let params = {
				'enCode': 'TiDB-xiazuan-stationNum',
                '@station_type': type === 0 ? '充电桩' : (type === 1 ? '换电站' : '全部'),
                '@ADCODE': province
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res) return
				let data = res && res[0] || {}
                if(!type && type !== 0) {
                    this.target1[0].number = data.total_station_num
                    this.target1[0].label = '充换电站数量(座)'
                } else {
                    this.target1[type].number = data.total_station_num
                }
                // this.$emit('editData', data.total_station_num, type)
			})
			.catch((err) => {
				console.log(err);
			});
		},
        zongheTaiShi2(data = {}) {
            let province = data.province || data.city || data.district || '000000'
			let params = {
				'enCode': 'TiDB-Energy-quanguo-leijichonghuandianxinxi',
                '@province': province
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res) return
				let data = res && res[0] || {}
                this.target1[2].number = data.exchangeOrChargeElect
                this.target1[3].number = data.exchangeOrChargeMileage
                this.target1[4].number = data.exchangeOrChargeNum
			})
			.catch((err) => {
				console.log(err);
			});
		},
    }
}
</script>

<style lang="scss" scoped>
@import '../scss/chd-com.scss';
</style>